import React, { useEffect, useState } from "react";
 import { useParams } from "react-router-dom";
import TreeComponent from "./TreeComponent";


function ReportTree({ setPageHeader, urlData }) {
  setPageHeader("");
  let { typ } = useParams();
  let { subtyp } = useParams();

  const [loading, setLoading] = useState(false);
  const [paramData, setParamsData] = useState();

  useEffect(() => {
    setLoading(true);
    if(urlData){
      setParamsData(urlData);
    } else {
      setParamsData({ typ: typ, subTyp: subtyp });
    };
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [typ, subtyp, urlData]);


  return !loading && (
    <div>
      <TreeComponent editSingleColumn={true} url="/report/reporttree"
        urlData={paramData}
        identity="" />
    </div>
  );
}

export default ReportTree;
